import React from 'react';
import { FaArrowRight, FaCheck } from 'react-icons/fa';
import './ServiceCard.css';

function ServiceCard({ service }) {
  const Icon = service.icon;

  return (
    <div className="service-card">
      <div className="service-icon">
        <Icon />
      </div>
      <h3>{service.title}</h3>
      <p>{service.description}</p>
      <ul className="service-features">
        {service.features.map((feature, index) => (
          <li key={index}>
            <FaCheck /> {feature}
          </li>
        ))}
      </ul>
      <a href="/services" className="learn-more">
        Learn More <FaArrowRight />
      </a>
    </div>
  );
}

export default ServiceCard;
